export default () => ({
  prevent_exit: false,
});
